import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {useTranslate} from "../useTranslate";


function Page(props) {

    const translate = useTranslate();
    const {user} = useSelector(state => state.auth);

    return (
        <div className="w-full h-full">
            {props.authorization && !user?(
                <>login please</>
            ):(
                <>
                    {/*<span className="font-bold text-4xl p-2 ">{translate(props.name)}</span>*/}
                    <div className={`flex flex-column ${props.className}`}>
                        {/*{props.rows&&props.rows.map(r=>(<Row {...r}/>))}*/}
                    </div>
                </>
            )}

        </div>
    );
}

export default Page;